import React, { useState } from 'react';
import { MapPin, CreditCard, Wallet, Truck, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { useApp } from '../context/AppContext';
import { Screen } from '../types';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function CheckoutScreen() {
  const {
    navigate
  } = useNavigation();
  const {
    cartTotal,
    placeOrder
  } = useApp();
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [loading, setLoading] = useState(false);
  const total = cartTotal + 4500;
  const handlePlaceOrder = () => {
    setLoading(true);
    setTimeout(() => {
      placeOrder('123 Main St, New York, NY 10001');
      setLoading(false);
      navigate(Screen.ORDER_CONFIRM);
    }, 1500);
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-gray-50 pb-24" data-id="element-335">
      <Header title="Checkout" data-id="element-336" />

      <div className="p-4 space-y-4" data-id="element-337">
        {/* Shipping Address */}
        <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-50" data-id="element-338">
          <div className="flex justify-between items-center mb-3" data-id="element-339">
            <h3 className="font-bold text-gray-900 flex items-center gap-2" data-id="element-340">
              <MapPin className="w-5 h-5 text-primary" data-id="element-341" /> Shipping Address
            </h3>
            <button className="text-sm font-medium text-primary" data-id="element-342">Change</button>
          </div>
          <div className="text-sm text-gray-600 pl-7" data-id="element-343">
            <p className="font-medium text-gray-900 mb-1" data-id="element-344">John Doe</p>
            <p data-id="element-345">123 Main Street, Apt 4B</p>
            <p data-id="element-346">New York, NY 10001</p>
            <p className="mt-1" data-id="element-347">+1 (234) 567-8900</p>
          </div>
        </div>

        {/* Delivery Options */}
        <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-50" data-id="element-348">
          <h3 className="font-bold text-gray-900 flex items-center gap-2 mb-3" data-id="element-349">
            <Truck className="w-5 h-5 text-primary" data-id="element-350" /> Delivery Options
          </h3>
          <div className="space-y-3" data-id="element-351">
            <label className="flex items-center justify-between p-3 border border-primary bg-primary/5 rounded-xl cursor-pointer" data-id="element-352">
              <div className="flex items-center gap-3" data-id="element-353">
                <input type="radio" name="delivery" defaultChecked className="text-primary focus:ring-primary" data-id="element-354" />
                <div data-id="element-355">
                  <p className="font-medium text-gray-900 text-sm" data-id="element-356">
                    Standard Delivery
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-357">
                    Est. 3-5 business days
                  </p>
                </div>
              </div>
              <span className="font-medium text-gray-900 text-sm" data-id="element-358">₦4,500</span>
            </label>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-50" data-id="element-359">
          <h3 className="font-bold text-gray-900 flex items-center gap-2 mb-3" data-id="element-360">
            <CreditCard className="w-5 h-5 text-primary" data-id="element-361" /> Payment Method
          </h3>
          <div className="space-y-3" data-id="element-362">
            <label className={`flex items-center justify-between p-3 border rounded-xl cursor-pointer transition-colors ${paymentMethod === 'card' ? 'border-primary bg-primary/5' : 'border-gray-200'}`} data-id="element-363">
              <div className="flex items-center gap-3" data-id="element-364">
                <input type="radio" name="payment" checked={paymentMethod === 'card'} onChange={() => setPaymentMethod('card')} className="text-primary focus:ring-primary" data-id="element-365" />
                <div className="flex items-center gap-2" data-id="element-366">
                  <div className="w-8 h-6 bg-primary-800 rounded flex items-center justify-center text-[8px] text-white font-bold italic" data-id="element-367">
                    VISA
                  </div>
                  <span className="font-medium text-gray-900 text-sm" data-id="element-368">
                    •••• 4242
                  </span>
                </div>
              </div>
            </label>
            <label className={`flex items-center justify-between p-3 border rounded-xl cursor-pointer transition-colors ${paymentMethod === 'wallet' ? 'border-primary bg-primary/5' : 'border-gray-200'}`} data-id="element-369">
              <div className="flex items-center gap-3" data-id="element-370">
                <input type="radio" name="payment" checked={paymentMethod === 'wallet'} onChange={() => setPaymentMethod('wallet')} className="text-primary focus:ring-primary" data-id="element-371" />
                <div className="flex items-center gap-2" data-id="element-372">
                  <Wallet className="w-5 h-5 text-gray-600" data-id="element-373" />
                  <span className="font-medium text-gray-900 text-sm" data-id="element-374">
                    Jummall Wallet (₦90,000)
                  </span>
                </div>
              </div>
            </label>
          </div>
        </div>

        {/* Order Summary */}
        <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-50" data-id="element-375">
          <h3 className="font-bold text-gray-900 mb-3" data-id="element-376">Order Summary</h3>
          <div className="space-y-2 text-sm" data-id="element-377">
            <div className="flex justify-between text-gray-600" data-id="element-378">
              <span data-id="element-379">Items Total</span>
              <span className="font-medium text-gray-900" data-id="element-380">
                ₦{cartTotal.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between text-gray-600" data-id="element-381">
              <span data-id="element-382">Delivery Fee</span>
              <span className="font-medium text-gray-900" data-id="element-383">₦4,500</span>
            </div>
            <div className="h-px bg-gray-100 my-2" data-id="element-384"></div>
            <div className="flex justify-between text-base font-bold text-gray-900" data-id="element-385">
              <span data-id="element-386">Total Payment</span>
              <span className="text-primary" data-id="element-387">₦{total.toLocaleString()}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 p-4 pb-safe z-40" data-id="element-388">
        <div className="max-w-md mx-auto" data-id="element-389">
          <Button fullWidth onClick={handlePlaceOrder} loading={loading} data-id="element-390">
            Place Order
          </Button>
          <p className="text-center text-xs text-gray-500 mt-3" data-id="element-391">
            By placing this order, you agree to our Terms & Conditions
          </p>
        </div>
      </div>
    </motion.div>;
}